import dayjs from 'dayjs'

export const createDateString = (props: { date: string; language: string }) => {
  const dateDayJs = dayjs(props.date).locale(props.language)
  return `${dateDayJs.format('MM/DD')} (${dateDayJs.format('dd')})`
}
